var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Modal", { ref: "modal", attrs: { bgcolor: "rgba(0,0,0,0.3)" } }, [
    _c("div", { staticClass: "not-support-wrwapper" }, [
      _c("i", { staticClass: "isif isif-close", on: { click: _vm.hide } }),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "copied-message", class: { active: _vm.alreadyCopied } },
        [_vm._v("\n      " + _vm._s(_vm.$t("Copied")) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "not-support-wrwapper-container" }, [
        _c("img", {
          staticClass: "not-support-image",
          attrs: { src: _vm.noSupportedImage, alt: "Not Supported" },
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "not-support-title",
          domProps: { textContent: _vm._s(_vm.$t("WebRTCNotSupportTitle")) },
        }),
        _vm._v(" "),
        _vm.isClipboardSupport
          ? _c("button", {
              ref: "copyButton",
              staticClass: "copy-button",
              attrs: { "data-clipboard-text": _vm.copyUrl },
              domProps: {
                textContent: _vm._s(_vm.$t("WebRTCNotSupportCopyButton")),
              },
              on: { click: _vm.copy },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("p", {
          staticClass: "not-support-text",
          domProps: { textContent: _vm._s(_vm.WebRTCNotSupportDesc) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }